module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image6-2d2cdd7c1f87d08209b01f3b93327fe5.png";